import { useTheme } from "@mui/material"

export default function Basket({size = 20}) {
    const theme = useTheme();

    const baseWidth = 20;
    const baseHeight = 20;
  
    const height = (baseHeight * size) / baseWidth;

    return (
        <svg 
            width={baseWidth}
            height={height} 
            viewBox="0 0 20 20" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <path 
                d="M16.6667 8.33203L15.4287 14.5217C15.276 15.2853 15.1997 15.6671 15.0003 15.9527C14.8245 16.2045 14.5825 16.4029 14.3011 16.5259C13.9819 16.6654 13.5926 16.6654 12.8138 16.6654H7.18614C6.40742 16.6654 6.01805 16.6654 5.69891 16.5259C5.41747 16.4029 5.1755 16.2045 4.9997 15.9527C4.80034 15.6671 4.72398 15.2853 4.57126 14.5217L3.33333 8.33203M16.6667 8.33203H15M16.6667 8.33203H17.5M3.33333 8.33203H2.5M3.33333 8.33203H5M15 8.33203H5M15 8.33203L12.5 3.33203M5 8.33203L7.5 3.33203M7.5 10.832V13.332M10 10.832V13.332M12.5 10.832V13.332" 
                stroke={theme.palette.rgd.primary} 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
        </svg>
    )
}